import { TaxCalculation } from '@/api/tax-guide';
import React, { Dispatch, SetStateAction } from 'react';
import { createContext, PropsWithChildren, useState } from 'react';

export type CalculationModalContext = {
  showModal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  modalValues: Array<TaxCalculation>;
  setModalValues: Dispatch<SetStateAction<Array<TaxCalculation>>>;
};

export const ModalContext = createContext<CalculationModalContext>({
  showModal: false,
  setModal: () => {
    return;
  },
  modalValues: [],
  setModalValues: () => {
    return;
  },
});

export function ModalProvider({ children }: PropsWithChildren) {
  const [showModal, setModal] = useState(false);
  const [modalValues, setModalValues] = useState<Array<TaxCalculation>>([]);

  return (
    <ModalContext.Provider
      value={{ showModal, setModal, modalValues, setModalValues }}
    >
      {children}
    </ModalContext.Provider>
  );
}
